import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  accent?: "yellow" | "purple" | "blue" | "green" | "red" | "none";
  className?: string;
  onClick?: () => void;
};

const accentBar: Record<NonNullable<Props["accent"]>, string> = {
  yellow: "before:bg-brand-yellow",
  purple: "before:bg-brand-purple",
  blue: "before:bg-brand-blue",
  green: "before:bg-brand-green",
  red: "before:bg-brand-red",
  none: "before:hidden",
};

export function Card({ children, accent = "none", className = "", onClick }: Props) {
  return (
    <div
      onClick={onClick}
      className={`
        relative bg-surface rounded-[var(--radius-lg)] overflow-hidden
        shadow-[var(--shadow-card)]
        border border-ink-100
        before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0
        before:w-1
        ${accentBar[accent]}
        ${onClick ? "cursor-pointer hover:shadow-[var(--shadow-card-hover)] active:scale-[0.995] transition-all duration-150" : ""}
        ${className}
      `}
    >
      {children}
    </div>
  );
}
